export default __webpack_public_path__ + "static/media/icon_reader_pause.752c5099.svg";